/* ==========================================================================
   basis-simulateur-cout.js

   Simulateur de cout de traitement. Porte de la maquette
   TEMPORAIRE/2026-08-24_simulateur-cout-v3-etapes.html (qui remplace la v2 du
   2026-08-21), avec les ecarts imposes par
   .claude/notes/components/simulateurs.md §5 :
     - tout est borne a la racine du composant, aucun selecteur global ;
     - `if (!ROOT) return;` partout ou une donnee peut manquer ;
     - l'URL de collecte est lue du JSON de la page, jamais ecrite en dur.

   PARTAGE DES ROLES (frontiere du §2 de la meme note) :
     - ICI, dans le code : le MODELE - grilles desinsectiseur, temps par geste,
       modes de comparaison, verdicts, formulations imposees. Sourcé, donc
       modifiable seulement par une PR.
     - Dans le metaobjet `simulateur_cas` : l'editorial et la composition.
     - Dans les produits : les PRIX, lus au rendu. Aucun montant n'est ecrit ici.
   ========================================================================== */
(function () {
  'use strict';

  /* --- Barèmes désinsectiseur - §4 bis de CONCEPTION.md, relevé d'août 2026,
         2 passages, TTC, hors Île-de-France. ------------------------------- */
  var CHIMIQUE = [
    { max: 30,  bas: 250, central: 320, haut: 400,  label: '≤ 30 m²',    pieces: 1, couchages: 1 },
    { max: 60,  bas: 380, central: 480, haut: 600,  label: '31-60 m²',   pieces: 2, couchages: 1 },
    { max: 90,  bas: 480, central: 600, haut: 750,  label: '61-90 m²',   pieces: 3, couchages: 2 },
    { max: 120, bas: 600, central: 760, haut: 950,  label: '91-120 m²',  pieces: 4, couchages: 2 },
    { max: 150, bas: 700, central: 880, haut: 1100, label: '121-150 m²', pieces: 5, couchages: 3 }
  ];
  var LOURD = [
    { max: 30,  bas: 750,  central: 950,  haut: 1100 },
    { max: 60,  bas: 1200, central: 1400, haut: 1700 },
    { max: 90,  bas: 1550, central: 1900, haut: 2500 },
    { max: 120, bas: 1850, central: 2300, haut: 3200 },
    { max: 150, bas: 2150, central: 2800, haut: 4000 }
  ];
  var IDF_MULT = 1.20;
  var IDF_DEPT = ['75', '77', '78', '91', '92', '93', '94', '95'];
  var DATE_RELEVE = 'août 2026';

  /* Temps laissé à l'occupant par un professionnel, les deux passages compris,
     tâches partagées incluses (§9 de la note du 2026-08-20). Une escalade
     thermique se fait en un passage : la moitié (dev, 2026-08-21). */
  /* Temps laisse a l'occupant par un professionnel. Bareme PAR PIECE donne par
     le dev le 2026-08-24 ; il remplace la constante plate de 225-725 min, qui ne
     bougeait ni avec la surface ni avec le nombre de pieces :
       - remise en cathedrale, matelas + sommier .... 30 min par piece
       - degagement du mobilier et des autres objets . 20 min par piece
       - mise en sac ................................ MIN_PAR_SAC par sac
     avant CHACUN des passages restants. Le nombre de sacs est celui que le
     visiteur a declare a l'etape 4, et non l'estimation « 2 a 3 par piece » du
     dev : on connait la vraie valeur, et les deux colonnes doivent compter les
     memes sacs. */
  var PRO_CATHEDRALE_MIN = 30;
  var PRO_DEGAGEMENT_MIN = 20;

  /* Duree : deux grandeurs a ne pas confondre (dev, 2026-08-24).
       - la PERIODE DE SUIVI d'infestation est la MEME quelle que soit la
         methode : elle depend du cycle de l'insecte, pas de qui traite ;
       - la PHASE DE TRAITEMENT, elle, differe : une seule fois chez nous,
         un rendez-vous puis deux passages espaces de 15 jours chez un
         professionnel.
     Le total pro est donc superieur d'au moins ces 15 jours, plus le delai de
     rendez-vous, qu'on ne chiffre pas faute de releve. */
  var SUIVI_SEMAINES = 5;
  var PRO_ENTRE_PASSAGES_SEM = 2;

  /* Barème des gestes, par cadre. Ne se déduit d'aucune donnée du catalogue. */
  var MODELE = {
    'cadre-1': { mode: 'passage_sup', perimetre: 'literie', court: "un traitement après le passage d'un désinsectiseur", travailCouchage: 60, travailFixe: 45,
      travailD: 'pièges, housses, diatomée sur la literie',
      incrTxt: 'housse matelas + housse sommier + lot de 4 pièges universels' },
    'cadre-2': { mode: 'chimique', perimetre: 'literie', court: 'une petite infestation', travailCouchage: 115, travailFixe: 45,
      travailD: 'pièges, housses, diatomée literie et plinthes, bombe de froid',
      incrTxt: 'lot de 4 OmniGuard + boîte de 4 pièges matelas + housse matelas + housse sommier' },
    'cadre-3': { mode: 'prevention', perimetre: 'literie', court: 'une protection en immeuble infesté', travailCouchage: 45, travailFixe: 0,
      travailD: 'pièges, housse de matelas, diatomée sur la literie',
      incrTxt: 'housse matelas + lot de 4 pièges universels, sans housse de sommier' },
    'cadre-4': { mode: 'depend', perimetre: 'complet', court: 'une infestation installée depuis des mois', travailCouchage: 200, travailFixe: 75,
      travailD: 'vapeur sur la literie et ses abords, pièges, housses, diatomée',
      incrTxt: "l'incrément du cadre 1 + une boîte de 4 pièges pour matelas",
      subq: { label: 'Avez-vous déjà fait appel à un désinsectiseur ?',
              help: "Cette réponse change l'alternative à laquelle nous nous comparons, donc tout le comparatif.",
              options: [{ v: 'oui', l: "Oui, et ça n'a pas suffi" }, { v: 'non', l: 'Non, jamais' }] } }
  };


  /* ======================================================================
     CONSOMMABLES - regles de modulation (dev, 2026-08-24)
     ----------------------------------------------------------------------
     Ce que le composant deploye ne fait pas : `produits()` met tout le lot
     `base` a q = 1 et ne module que `par_couchage`. Un spray de diatomee
     reste donc a 1 quel que soit le nombre de couchages, et la boite de
     25 sacs a 1 quel que soit le volume declare.

     Les valeurs de HYP sont les regles du dev, arretees le 2026-08-24. Elles
     pilotent des montants affiches : toute revision passe par
     SKER_ADMIN/OUTILS/simulateur-cout/A-TRANCHER-consommables.md
     ====================================================================== */
  var NB_ETAPES = 5;

  var HYP = {
    diatomeeParCouchages: 2,   /* literie : 1 spray pour 2 couchages */
    diatomeeParM2: 50,         /* complet : 1 spray par 50 m2 */
    bombeParSacs: 10,          /* 1 bombe pour ~10 sacs */
    /* Le « et/ou 1 piece » ne s'appliquait qu'au perimetre complet, donc au seul
       cadre 4 - qui ne porte plus de bombe depuis le 2026-08-24. Le reglage reste
       pour le jour ou un cadre complet en portera. */
    bombeCombinaison: 'max',
    bombeLiterie: true         /* plancher d'une bombe des qu'il y a traitement */
  };

  /* Fiches produit reelles, lues au catalogue public le 2026-08-24. Dans le
     composant elles viendront du metaobjet, pas d'ici. */
  var CATALOGUE = {
 "bombe-froid-anti-punaise-de-lit-nidoan": {
  "id": 40499440779300,
  "nom": "Bombe de froid anti punaise de lit NIDOAN®",
  "variante": "Bombe de froid anti punaise (Unité)",
  "prix": 1990,
  "url": "/products/bombe-froid-anti-punaise-de-lit-nidoan",
  "image": "//cdn.shopify.com/s/files/1/0102/0362/7556/files/spray_insecticide_froid_punaise_de_lit_nidoan.png?v=1786460262",
  "variantes": [
   {
    "titre": "Bombe de froid anti punaise (Unité)",
    "prix": 1990
   },
   {
    "titre": "Pack de 3 bombes de froid",
    "prix": 4490
   }
  ]
 },
 "detecteur-punaise-de-lit-lineaire-domobios": {
  "id": 39896716116004,
  "nom": "Pièges punaise de lit pour matelas DOMOBIOS®",
  "variante": "Boîte de 4 détecteurs",
  "prix": 2290,
  "url": "/products/detecteur-punaise-de-lit-lineaire-domobios",
  "image": "//cdn.shopify.com/s/files/1/0102/0362/7556/products/piege-detection-punaise-de-lit-domobios.jpg?v=1747381963",
  "variantes": [
   {
    "titre": "Boîte de 4 détecteurs",
    "prix": 2290
   },
   {
    "titre": "Pack de 12 détecteurs",
    "prix": 5400
   }
  ]
 },
 "sac-protecteur-punaise-de-lit-hydrosoluble": {
  "id": 39504775839780,
  "nom": "Sac protecteur hydrosoluble anti-punaise de lit",
  "variante": "5 sacs de 90 litres",
  "prix": 690,
  "url": "/products/sac-protecteur-punaise-de-lit-hydrosoluble",
  "image": "//cdn.shopify.com/s/files/1/0102/0362/7556/files/sac-hydrosoluble-punaise-de-lit-585955.jpg?v=1747381971",
  "variantes": [
   {
    "titre": "5 sacs de 90 litres",
    "prix": 690
   },
   {
    "titre": "25 sacs de 90 litres",
    "prix": 2590
   },
   {
    "titre": "50 sacs de 90 litres",
    "prix": 5090
   }
  ]
 },
 "terre-de-diatomee-punaise-de-lit-nidoan": {
  "id": 40499438125092,
  "nom": "Terre de Diatomée anti punaise de lit naturelle NIDOAN®",
  "variante": "Spray Terre de diatomée (Unité)",
  "prix": 1990,
  "url": "/products/terre-de-diatomee-punaise-de-lit-nidoan",
  "image": "//cdn.shopify.com/s/files/1/0102/0362/7556/files/spray-diatomee-nidoan.jpg?v=1789382802",
  "variantes": [
   {
    "titre": "Spray Terre de diatomée (Unité)",
    "prix": 1990
   },
   {
    "titre": "Pack de 3 sprays Terre de diatomée",
    "prix": 4970
   }
  ]
 }
};

  /* Contenu du « Pack traitement complet » a 89,90 EUR, lu sur sa fiche
     produit : 1 bombe de froid, 1 spray de diatomee, 1 lot de 4 OmniGuard,
     2 repulsifs, 1 lot de 5 sacs, 1 lot de 4 pieges matelas. Invisible dans
     la charge : a porter dans le metaobjet (champ a creer). */
  var PACK_INCLUS = { 'cadre-2': { diatomee: 1, bombe: 1, sac: 5, detecteur: 1 } };

  /* Ce qui reste apres le traitement, par opposition a ce qui se consomme.
     Le nettoyeur vapeur y est : il sert ensuite au menage courant (dev, 2026-08-24). */
  var DURABLES = ['housse-', 'piege-', 'detecteur-', 'nettoyeur-vapeur', 'kit-accessoires'];

  /* Le pack du cadre 2 n'est pas ventile dans la charge. Part durable estimee au
     prorata des prix unitaires de son contenu, lus sur sa fiche produit le
     2026-08-24 : 4 OmniGuard 26,90 + 4 pieges matelas 22,90 = 49,80 de durable,
     sur 108,40 de contenu total (+ bombe de froid 19,90, diatomee 16,90,
     repulsifs 14,90, 5 sacs 6,90), soit 45,9 %. A remplacer par le champ
     `consommables_inclus` du metaobjet des qu'il existe. */
  var PACK_DURABLE = { 'cadre-2': 0.459 };

  /* Ce que chaque cadre porte reellement - tranche par le dev le 2026-08-24.
     Remplace le repli devine, qui ajoutait aux cadres des produits qu'ils n'ont pas.
       - cadre 4 : PAS de bombe de froid. La vapeur la remplace, et elle tue les
         oeufs, ce que le froid ne fait pas.
       - cadre 3 : ni bombe ni sacs - il n'y a pas d'infestation a traiter.
       - cadres 1 et 3 : PAS de piege matelas, pour rester competitif. Sur le
         cadre 3 il releve de la detection, recommandee seulement si une
         infestation se declare.
     Reste ouvert : la bombe de froid du cadre 1, non tranchee. */
  var PORTE = {
    'cadre-1': { diatomee: true, bombe: true,  sac: true,  detecteur: false },
    'cadre-2': { diatomee: true, bombe: true,  sac: true,  detecteur: true  },
    'cadre-3': { diatomee: true, bombe: false, sac: false, detecteur: false },
    'cadre-4': { diatomee: true, bombe: false, sac: true,  detecteur: true  }
  };

  var FAMILLES = [
    { cle: 'diatomee',  handle: 'terre-de-diatomee',            lbl: 'Spray de terre de diatomée' },
    { cle: 'bombe',     handle: 'bombe-froid',                  lbl: 'Bombe de froid' },
    { cle: 'sac',       handle: 'sac-protecteur',               lbl: 'Sac protecteur hydrosoluble' },
    { cle: 'detecteur', handle: 'detecteur-punaise-de-lit-lin', lbl: 'Piège matelas' }
  ];

  /* Une phrase par cadre sur ce que couvrent les consommables du montant de
     base et ce qui se partage. Remplace la phrase generique de l'ancienne
     ligne 478, fausse sur 3 cadres sur 4. Redigee depuis les compositions
     reelles - A VALIDER par le dev. */
  var NOTE_CONSO = {
    'cadre-1': "Le montant de base équipe un couchage et comprend un spray de terre de diatomée. " +
      "La diatomée se partage : un spray couvre deux couchages. Ni bombe de froid ni sacs protecteurs " +
      "ne sont compris dans ce cadre.",
    'cadre-2': "Le pack de base contient une bombe de froid, un spray de terre de diatomée, cinq sacs " +
      "hydrosolubles, quatre pièges OmniGuard et quatre pièges pour matelas - de quoi traiter un couchage. " +
      "Au-delà, la diatomée se partage entre deux couchages, une bombe de froid couvre une dizaine de sacs, " +
      "et chaque sac d'affaires demande son sac protecteur.",
    'cadre-3': "Protection, pas traitement : un spray de terre de diatomée sur la literie, une housse et " +
      "des pièges par couchage. Pas de sacs ni de bombe de froid - il n'y a pas d'affaires à décontaminer.",
    'cadre-4': "Le montant de base couvre le nettoyeur vapeur, un spray de terre de diatomée, une boîte de " +
      "25 sacs hydrosolubles et une boîte de quatre pièges matelas. Ici la diatomée suit la surface, un spray " +
      "par 50 m², parce que le traitement sort de la literie. Environ un sac sur dix se traite à la diatomée " +
      "plutôt qu'en machine ou au froid."
  };

  var GABARITS = [{ v: 30, l: '30 L' }, { v: 40, l: '40 L' }, { v: 55, l: '55 L' }];
  var GABARIT_DEFAUT = 55;
  var CONTENANTS_PAR_CHAMBRE = 3;   /* défaut du dev, 2026-08-21. Non sourcé, commodité d'affichage */
  var SAC_LITRES = 90;              /* contenance du sac protecteur, lue au catalogue */
  /* Duree de mise en sac, par sac. Portee a 15 min le 2026-08-24 (dev) - le
     classeur du 2026-08-20 disait 7. Elle vaut pour LES DEUX colonnes : le
     nombre de sacs est celui que le visiteur declare a l'etape 4, et il sert de
     reference au professionnel comme a notre methode. */
  var MIN_PAR_SAC = 15;
  /* Attribution : tout lien produit sortant du simulateur porte ces trois
     parametres. Demande du dev, 2026-08-21. Les liens editoriaux (articles) n'en
     portent pas : on mesure ce que le simulateur envoie vers le catalogue. */
  var UTM = 'utm_source=website&utm_medium=simulator&utm_campaign=treatment-simulator';

  var LOGEMENTS = [
    { v: 'appartement_immeuble', l: 'Appartement en immeuble' },
    { v: 'maison_mitoyenne', l: 'Maison mitoyenne' },
    { v: 'maison_individuelle', l: 'Maison individuelle' }
  ];
  var VOISINS = [{ v: 'oui', l: 'Oui' }, { v: 'non', l: 'Non' }, { v: 'ne_sait_pas', l: 'Je ne sais pas' }];

  /* --- Utilitaires ------------------------------------------------------- */
  function eur(n) {
    return n == null ? '-' : n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
  }
  /* « et un couchage » se lit mieux que « et 1 couchage » dans une phrase. */
  var LETTRES = ['zéro', 'un', 'deux', 'trois', 'quatre', 'cinq', 'six', 'sept', 'huit', 'neuf', 'dix'];
  function enLettres(n) { return LETTRES[n] || String(n); }
  function eur0(n) { return n == null ? '-' : Math.round(n).toLocaleString('fr-FR') + ' €'; }
  function hm(min) {
    var h = Math.floor(min / 60), m = Math.round(min % 60);
    return h ? (h + 'h' + (m < 10 ? '0' : '') + m) : (m + ' min');
  }
  /* Le teaser n'affiche pas une somme de baremes a la minute : 181 min (115 par
     couchage + 45 de fixe + 3 sacs x 7) devient « environ 3 h ». Arrondi au quart
     d'heure, minutes omises quand elles tombent a zero. `hm()` reste inchange
     pour le detail, ou la decomposition est donnee juste a cote. */
  function hArrondi(min) {
    var q = Math.round(min / 15) * 15, h = Math.floor(q / 60), m = q % 60;
    if (!h) return m + ' min';
    return h + ' h' + (m ? (' ' + m) : '');
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function tranche(grille, s) {
    for (var i = 0; i < grille.length; i++) { if (s <= grille[i].max) return grille[i]; }
    return null;
  }

  /* Bornes de prix d'une ligne de panier, lues sur les variantes du produit.
     Seules les variantes dont le titre commence par « 1 place » / « 2 places »
     participent à la fourchette - sinon un lot de 12 pièges ferait passer
     l'incrément du simple au double. Aucune borne n'est écrite dans ce fichier. */
  function bornes(ligne) {
    var ref = ligne.prix / 100, un = [], deux = [];
    (ligne.variantes || []).forEach(function (v) {
      var t = (v.titre || '');
      if (t.indexOf('1 place') === 0) un.push(v.prix / 100);
      else if (t.indexOf('2 places') === 0) deux.push(v.prix / 100);
    });
    function mm(a) { return a.length ? { bas: Math.min.apply(null, a), haut: Math.max.apply(null, a) } : { bas: ref, haut: ref }; }
    return { p1: mm(un), p2: mm(deux) };
  }
  function sommeRef(lignes) {
    return lignes.reduce(function (t, l) { return t + l.prix / 100; }, 0);
  }
  function sommeBornes(lignes, cle) {
    return lignes.reduce(function (acc, l) {
      var b = bornes(l)[cle];
      return { bas: acc.bas + b.bas, haut: acc.haut + b.haut };
    }, { bas: 0, haut: 0 });
  }


  /* --- Conditionnement : choisir les variantes les moins cheres -----------
     Les variantes de chaque produit sont DEJA dans la charge (le snippet les
     transporte, lignes 93-96 et 110-113) : rien a changer cote Liquid.
     Exemple : 16 sacs coutent 25,90 en une boite de 25, contre 27,60 en
     quatre lots de 5. La bascule tombe a 16. */
  function tailleVariante(titre, famille) {
    var t = String(titre || ''), m;
    if (famille === 'sac') { m = t.match(/(\d+)\s*sacs/i); return m ? parseInt(m[1], 10) : 1; }
    if (famille === 'detecteur') { m = t.match(/Pack de (\d+)/i); return m ? Math.round(parseInt(m[1], 10) / 4) : 1; }
    m = t.match(/Pack de (\d+)/i);
    return m ? parseInt(m[1], 10) : 1;
  }
  /* Programmation dynamique : cout minimal pour couvrir AU MOINS q unites.
     Les quantites sont petites (< 60), le cout est negligeable. */
  function conditionnement(produit, famille, Q) {
    if (Q <= 0) return { lignes: [], total: 0 };
    var vs = (produit.variantes || []).map(function (v) {
      return { titre: v.titre, prix: v.prix / 100, n: tailleVariante(v.titre, famille) };
    }).filter(function (v) { return v.n > 0; });
    if (!vs.length) return { lignes: [{ titre: '', prix: produit.prix / 100, q: Q, n: 1 }], total: produit.prix / 100 * Q };
    var best = [0], from = [null], q, i;
    for (q = 1; q <= Q; q++) {
      best[q] = Infinity;
      for (i = 0; i < vs.length; i++) {
        var cand = best[Math.max(0, q - vs[i].n)] + vs[i].prix;
        if (cand < best[q] - 1e-9) { best[q] = cand; from[q] = i; }
      }
    }
    var compte = {}, reste = Q;
    while (reste > 0) { var k = from[reste]; compte[k] = (compte[k] || 0) + 1; reste = Math.max(0, reste - vs[k].n); }
    var lignes = [], total = 0;
    Object.keys(compte).forEach(function (k) {
      var v = vs[k];
      lignes.push({ titre: v.titre, prix: v.prix, q: compte[k], n: v.n });
      total += v.prix * compte[k];
    });
    return { lignes: lignes, total: total };
  }

  /* ======================================================================
     UNE INSTANCE
     ====================================================================== */
  function mount(root) {
    var uid = root.getAttribute('data-apsc');
    var noeud = document.getElementById('apsc-data-' + uid);
    if (!noeud) return;

    var data;
    try { data = JSON.parse(noeud.textContent); } catch (e) { return; }
    if (!data || !data.cadres) return;

    var cadres = data.cadres
      .filter(function (c) { return MODELE[c.cle]; })
      .sort(function (a, b) { return (a.ordre || 99) - (b.ordre || 99); })
      .map(function (c) {
        var m = MODELE[c.cle];
        return {
          cle: c.cle, titre: c.titre, base: c.base || [], parCouchage: c.par_couchage || [],
          option: c.option || null, certitude: c.certitude, certitudeD: c.certitude_detail,
          vigilance: c.vigilance, calendaire: c.duree, calendaireD: c.duree_detail,
          mode: m.mode, perimetre: m.perimetre, court: m.court, travailCouchage: m.travailCouchage, travailFixe: m.travailFixe,
          travailD: m.travailD, incrTxt: m.incrTxt, subq: m.subq || null
        };
      });
    if (!cadres.length) return;

    var zoneQ = root.querySelector('[data-apsc-questions]');
    var zoneR = root.querySelector('[data-apsc-result]');
    var zoneT = root.querySelector('[data-apsc-teaser]');
    if (!zoneQ || !zoneR) return;

    var SESSION = String(Math.random()).slice(2, 12);

    var etat = {
      cadre: cadres[1] ? cadres[1].cle : cadres[0].cle,   /* défaut : petite infestation */
      dejaPro: null, surface: 45, pieces: null, couchages: null, lits2p: 0,
      gabarit: GABARIT_DEFAUT, contenants: null, contenantsCorrige: 0,
      logement: 'appartement_immeuble', voisins: 'ne_sait_pas', cp: '', devis: '',
      etape: 1, etapeMax: 0,   /* etapeMax = 0 tant que le panneau n'a pas ete ouvert */
      calcule: false   /* le comparatif complet n'arrive qu'au bout des 5 etapes */
    };

    function cadre() {
      for (var i = 0; i < cadres.length; i++) { if (cadres[i].cle === etat.cadre) return cadres[i]; }
      return cadres[0];
    }
    function deduit(s) {
      var t = tranche(CHIMIQUE, s);
      return t ? { pieces: t.pieces, couchages: t.couchages } : { pieces: 6, couchages: 3 };
    }
    function pieces() { return etat.pieces !== null ? etat.pieces : deduit(etat.surface).pieces; }
    function couchages() { return etat.couchages !== null ? etat.couchages : deduit(etat.surface).couchages; }
    function lits2p() { return Math.min(etat.lits2p, couchages()); }
    function estIDF() { return etat.cp.length === 5 && IDF_DEPT.indexOf(etat.cp.slice(0, 2)) !== -1; }
    function contenants() { return etat.contenants !== null ? etat.contenants : CONTENANTS_PAR_CHAMBRE * couchages(); }
    function litres() { return contenants() * etat.gabarit; }
    /* Un contenant = un sac : le sac de 90 L ne se remplit jamais à ras
       (arbitrage du dev, 2026-08-21). */
    function sacs() { return contenants(); }
    function tauxRemplissage() { return Math.round(etat.gabarit / SAC_LITRES * 100); }

    function modeEffectif(c) {
      if (c.mode !== 'depend') return c.mode;
      if (etat.dejaPro === null) return null;
      return etat.dejaPro === 'oui' ? 'lourd' : 'chimique';
    }
    /* --- Consommables : quantites requises et supplements --------------- */
    function ligneFamille(lot, handle) {
      for (var i = 0; i < lot.length; i++) {
        if (String(lot[i].url || '').indexOf(handle) !== -1) return lot[i];
      }
      return null;
    }
    /* Ce que le montant de base couvre deja : soit une ligne du lot `base`
       (dont on lit la taille de variante - la boite de 25 sacs du cadre-4
       vaut 25, pas 1), soit le contenu d'un pack, invisible dans la charge. */
    function inclus(c, f) {
      var l = ligneFamille(c.base, f.handle);
      var n = l ? tailleVariante(variante(l), f.cle) : 0;
      var p = PACK_INCLUS[c.cle];
      return n + ((p && p[f.cle]) || 0);
    }
    function requis(c, f) {
      var porte = PORTE[c.cle];
      if (porte && !porte[f.cle]) return 0;
      var n = couchages(), P = pieces(), C = sacs(), S = etat.surface;
      var complet = (c.perimetre === 'complet');
      var prevention = (c.mode === 'prevention');
      if (f.cle === 'diatomee') {
        var parLits = Math.ceil(n / HYP.diatomeeParCouchages);
        return complet ? Math.max(Math.ceil(S / HYP.diatomeeParM2), parLits) : parLits;
      }
      if (f.cle === 'bombe') {
        if (prevention) return 0;
        var bs = Math.ceil(C / HYP.bombeParSacs), bp = complet ? P : 0;
        var v = (HYP.bombeCombinaison === 'somme') ? (bs + bp) : Math.max(bs, bp);
        return Math.max(v, HYP.bombeLiterie ? 1 : 0);
      }
      if (f.cle === 'sac') return prevention ? 0 : C;
      if (f.cle === 'detecteur') return prevention ? 0 : n;
      return 0;
    }
    /* Un cadre peut ne pas porter le produit du tout (le detecteur matelas
       est absent des cadres 1 et 3, la bombe de froid des cadres 1, 3 et 4).
       Question ouverte au dev : oubli ou perimetre voulu. */
    function produitDe(c, f) {
      return ligneFamille(c.base, f.handle) || ligneFamille(c.parCouchage, f.handle) ||
             CATALOGUE[Object.keys(CATALOGUE).filter(function (h) {
               return h.indexOf(f.handle) !== -1; })[0]] || null;
    }
    function estDurable(l) {
      var u = String(l.url || '');
      for (var i = 0; i < DURABLES.length; i++) { if (u.indexOf(DURABLES[i]) !== -1) return true; }
      return false;
    }
    /* Somme calculee sur la MEME borne que `ap.bas`, sinon le pourcentage rendu
       comparerait deux bases differentes. */
    function coutDurable(c) {
      var tot = 0;
      c.base.forEach(function (l) {
        if (PACK_DURABLE[c.cle] && c.base.length === 1) tot += l.prix / 100 * PACK_DURABLE[c.cle];
        else if (estDurable(l)) tot += l.prix / 100;
      });
      var n2 = lits2p(), n1 = couchages() - n2;
      var sup1 = Math.max(0, n1 - 1), reste = Math.max(0, 1 - n1), sup2 = Math.max(0, n2 - reste);
      var dur = c.parCouchage.filter(estDurable);
      var b1 = sommeBornes(dur, 'p1'), b2 = sommeBornes(dur, 'p2');
      tot += sup1 * b1.bas + sup2 * b2.bas;
      /* Parmi les supplements de consommables, seul le piege matelas est durable. */
      consommables(c).lignes.forEach(function (x) {
        if (x.f.cle === 'detecteur') tot += x.cond.total;
      });
      return tot;
    }
    function consommables(c) {
      var out = [], somme = 0;
      FAMILLES.forEach(function (f) {
        var Q = requis(c, f), dedans = inclus(c, f), sup = Math.max(0, Q - dedans);
        var prod = produitDe(c, f);
        if (!prod) return;
        var cond = sup ? conditionnement(prod, f.cle, sup) : { lignes: [], total: 0 };
        somme += cond.total;
        out.push({ f: f, requis: Q, inclus: dedans, sup: sup, prod: prod, cond: cond });
      });
      return { lignes: out, total: somme };
    }

    function coutPro(c) {
      var mode = modeEffectif(c);
      if (mode === null) return { enAttente: true };
      var grille = (mode === 'lourd') ? LOURD : CHIMIQUE;
      var t = tranche(grille, etat.surface);
      if (!t) return { horsGrille: true };
      var m = estIDF() ? IDF_MULT : 1, f = (mode === 'passage_sup') ? 0.5 : 1;
      var r = { mode: mode, bas: t.bas * m * f, central: t.central * m * f, haut: t.haut * m * f,
                tranche: tranche(CHIMIQUE, etat.surface).label, idf: estIDF() };
      if (mode === 'passage_sup') {
        r.titre = 'Un 3e passage';
        r.note = "après deux échecs, moitié d'un traitement à 2 passages";
        var tl = tranche(LOURD, etat.surface);
        if (tl) r.escalade = tl.central * m;
        /* Le cadre 1 arrive APRES un traitement chimique deja paye. Ne montrer
           que le 3e passage revient a effacer cette depense de la comparaison
           (dev, 2026-08-24). `t` est ici la tranche chimique pleine, deux
           passages : c'est l'estimation de ce qui a deja ete depense. */
        r.dejaPaye = t.central * m;
        r.dejaPayeBas = t.bas * m;
        r.dejaPayeHaut = t.haut * m;
      } else if (mode === 'lourd') { r.titre = 'Escalade thermique ou cryogénie'; r.note = 'passage unique'; }
      else if (mode === 'prevention') { r.titre = "S'il faut traiter une infestation"; r.note = '2 passages inclus'; }
      else { r.titre = 'Désinsectiseur chimique'; r.note = '2 passages inclus'; }
      return r;
    }
    function coutAp(c) {
      var base = sommeRef(c.base);
      var n2 = lits2p(), n1 = couchages() - n2;
      var sup1 = Math.max(0, n1 - 1), reste = Math.max(0, 1 - n1), sup2 = Math.max(0, n2 - reste);
      var b1 = sommeBornes(c.parCouchage, 'p1'), b2 = sommeBornes(c.parCouchage, 'p2');
      var addBas = sup1 * b1.bas + sup2 * b2.bas;
      var addHaut = sup1 * b1.haut + sup2 * b2.haut;
      /* Les consommables s'ajoutent aux deux bornes : leur quantite ne depend
         pas de la taille des couchages, donc ils ne creusent pas la fourchette. */
      var cons = consommables(c).total;
      return { base: base, conso: cons, bas: base + addBas + cons, haut: base + addHaut + cons,
               fourchette: addHaut > addBas };
    }
    /* Nombre de passages restant a preparer. Un 3e passage est UN passage : le
       code precedent appliquait au cadre 1 la preparation des deux, ce qui
       surestimait le temps du professionnel. */
    function passagesPro(c) {
      var mode = modeEffectif(c);
      if (mode === 'prevention' || mode === null) return 0;
      return (mode === 'lourd' || mode === 'passage_sup') ? 1 : 2;
    }
    function travailPro(c) {
      var p = passagesPro(c);
      if (!p) return null;
      var parPassage = pieces() * (PRO_CATHEDRALE_MIN + PRO_DEGAGEMENT_MIN) + sacs() * MIN_PAR_SAC;
      return { total: parPassage * p, parPassage: parPassage, passages: p };
    }
    function travailAp(c) {
      var geste = c.travailCouchage * couchages() + c.travailFixe;
      var sac = (c.mode === 'prevention') ? 0 : sacs() * MIN_PAR_SAC;
      return { total: geste + sac, geste: geste, sac: sac };
    }

    /* --- Fragments de rendu --------------------------------------------- */
    function pastilles(items, valeur, attr, inline) {
      return '<div class="apsc-pills' + (inline ? ' apsc-pills--inline' : '') + '">' +
        items.map(function (o) {
          return '<button type="button" class="apsc-pill" data-v="' + esc(o.v) + '" data-attr="' + attr + '"' +
            ' aria-pressed="' + (String(o.v) === String(valeur)) + '">' + esc(o.l) + '</button>';
        }).join('') + '</div>';
    }
    function stepper(attr, label, val, auto, min, max) {
      return '<div class="apsc-stepper' + (auto ? '' : ' apsc-stepper--edited') + '">' +
        '<span class="apsc-stepper__lbl">' + esc(label) + '</span>' +
        '<span class="apsc-stepper__ctrl">' +
          '<button type="button" class="apsc-stepper__btn" data-step="-1" data-attr="' + attr + '"' +
            (val <= min ? ' disabled' : '') + ' aria-label="Moins">-</button>' +
          '<span class="apsc-stepper__n">' + val + '</span>' +
          '<button type="button" class="apsc-stepper__btn" data-step="1" data-attr="' + attr + '"' +
            (val >= max ? ' disabled' : '') + ' aria-label="Plus">+</button>' +
          '<span class="apsc-stepper__auto">' + (auto ? 'déduit' : 'corrigé') + '</span>' +
        '</span></div>';
    }
    /* Emojis de tete de ligne. Trois viennent du tableau comparatif des
       repulsifs (💰 le prix, 🎯 la cible, ⚠️ la vigilance sante) ; l'horloge et
       le calendrier sont des ajouts, cette page n'ayant pas de marqueur de temps. */
    function axe(label, apV, apD, proV, proD, proVide, emoji) {
      return '<div class="apsc-axe"><p class="apsc-axe__lbl">' +
        (emoji ? '<span class="apsc-axe__emo" aria-hidden="true">' + emoji + '</span> ' : '') +
        esc(label) + '</p>' +
        '<div class="apsc-axe__grid">' +
          '<div class="apsc-axe__cell apsc-axe__cell--ap"><p class="apsc-axe__who">Avec AlloPunaise</p>' +
            '<p class="apsc-axe__v">' + apV + '</p><p class="apsc-axe__d">' + apD + '</p></div>' +
          '<div class="apsc-axe__cell' + (proVide ? ' apsc-axe__cell--none' : '') + '">' +
            '<p class="apsc-axe__who">Avec un professionnel</p>' +
            '<p class="apsc-axe__v">' + proV + '</p><p class="apsc-axe__d">' + proD + '</p></div>' +
        '</div></div>';
    }
    function lienProduit(url) {
      if (!url) return '';
      return url + (url.indexOf('?') === -1 ? '?' : '&') + UTM;
    }
    /* Un produit sans declinaison rend « Default Title » cote Shopify : ce n'est
       pas un libelle, c'est un defaut technique. Il ne s'affiche jamais. */
    function variante(l) {
      var v = l.variante || '';
      return (v === 'Default Title' || v === 'Title') ? '' : v;
    }
    function carte(l, q) {
      var det = variante(l), qte = q > 1 ? (q + ' x ') : '';
      return '<a class="apsc-prod" target="_blank" rel="noopener" href="' + esc(lienProduit(l.url)) + '">' +
        (l.image ? '<img src="' + esc(l.image) + '" alt="" width="52" height="52" loading="lazy">' : '') +
        '<span class="apsc-prod__txt"><span class="apsc-prod__n">' + esc(l.nom) + '</span>' +
        ((qte || det) ? ('<span class="apsc-prod__q">' + qte + esc(det) + '</span>') : '') +
        '</span>' +
        '<span class="apsc-prod__p">' + eur(l.prix / 100 * q) + '</span></a>';
    }
    function produits(c) {
      var n = couchages(), lignes = [];
      c.base.forEach(function (l) { lignes.push({ l: l, q: 1 }); });
      if (n > 1) {
        c.parCouchage.forEach(function (l) {
          var deja = null;
          lignes.forEach(function (x) { if (x.l.id === l.id) deja = x; });
          if (deja) deja.q += (n - 1); else lignes.push({ l: l, q: n - 1 });
        });
      }
      return lignes.map(function (x) { return carte(x.l, x.q); }).join('');
    }
    function voies() {
      var s = sacs();
      return '<p class="apsc-block__h">Vos affaires : ' + litres().toLocaleString('fr-FR') + ' L, dans ' +
        s + ' sac' + (s > 1 ? 's' : '') + ' de 90 L</p>' +
        '<ul class="apsc-voies">' +
        '<li class="is-reco"><b>48 à 72 h</b><span>Quarantaine dans le sac avec de la diatomée pulvérisée dedans. ' +
          '<b>Tous les sacs en même temps</b> : ' + s + ' sacs prennent le même temps qu\'un seul.</span></li>' +
        '<li><b>1h30 + 30 min</b><span>Lave-linge à 60 °C, cycle complet, puis sèche-linge. Par machine.</span></li>' +
        '<li><b>2 h</b><span>Tente chauffante, par cycle et par charge.</span></li>' +
        '<li><b>72 h</b><span>Congélateur, par passage - et le nombre de passages dépend du volume de votre appareil. ' +
          'Voir l\'article congélateur ci-dessous.</span></li>' +
        '</ul>';
    }
    function verdict(c, pro, ap) {
      if (pro.enAttente) {
        return '<div class="apsc-verdict apsc-verdict--neutral">Répondez à la question ci-dessus pour afficher ' +
          "la comparaison : le contrefactuel n'est pas le même selon qu'un traitement chimique a déjà échoué ou non.</div>";
      }
      if (pro.horsGrille) {
        return '<div class="apsc-verdict apsc-verdict--neutral">Au-delà de 150 m², les grilles publiées ne vont pas ' +
          'plus loin. Demandez deux devis, et comparez-les à notre colonne.</div>';
      }
      if (c.mode === 'prevention') {
        return '<div class="apsc-verdict apsc-verdict--neutral"><b>' + eur(ap.bas) + '</b> pour vous protéger, contre <b>' +
          eur0(pro.central) + '</b> au milieu de la fourchette s\'il faut un jour traiter une infestation déclarée. ' +
          'Ce sont deux dépenses de nature différente : un professionnel ne traite pas un logement sain.</div>';
      }
      var cls, txt;
      if (ap.haut < pro.central) {
        var e1 = pro.central - ap.haut, e2 = pro.central - ap.bas;
        cls = 'ok';
        txt = '<b>Moins cher</b> : ' + (ap.fourchette ? ('de ' + eur(ap.bas) + ' à ' + eur(ap.haut)) : eur(ap.bas)) +
          ' contre <b>' + eur0(pro.central) + '</b> au milieu de la fourchette, soit un écart de ' +
          (ap.fourchette ? (eur0(e1) + ' à ' + eur0(e2)) : eur0(e2)) + '.';
      } else if (ap.bas <= pro.central) {
        cls = 'neutral';
        txt = '<b>Cela dépend de la taille de vos couchages</b> : de ' + eur(ap.bas) + ' avec des 1 place à ' +
          eur(ap.haut) + ' avec de grands 2 places, contre <b>' + eur0(pro.central) + '</b> au milieu de la fourchette.';
      } else {
        cls = 'warn';
        txt = '<b>Plus cher</b> : à partir de ' + eur(ap.bas) + ' contre <b>' + eur0(pro.central) +
          '</b> au milieu de la fourchette. Ce qui se joue ici n\'est pas le montant mais l\'issue : les punaises ' +
          'qui survivent à un traitement donnent une génération qui, elle, ne meurt presque plus. Sur le mélange ' +
          'pyréthrinoïde-néonicotinoïde, une seule génération suffit pour que la mortalité tombe de 69,2 % à ' +
          '1,6 % (Gordon, 2014). Et dès 2012, 37,8 % des punaises d\'un site de banlieue parisienne résistaient ' +
          'déjà aux pyréthrinoïdes (Durand, 2012).';
      }
      if (c.mode === 'passage_sup' && pro.escalade) {
        txt += ' Face à une escalade thermique, qui est l\'autre suite possible après deux échecs, le milieu de la ' +
          'fourchette est de ' + eur0(pro.escalade) + '.';
      }
      return '<div class="apsc-verdict apsc-verdict--' + cls + '">' + txt + '</div>';
    }

    /* --- Rendu ----------------------------------------------------------- */
    function render() {
      var c = cadre(), pro = coutPro(c), ap = coutAp(c), tr = travailAp(c), n = couchages();

      /* --- Assistant pas a pas (arbitrage du dev, 2026-08-24) -------------
         Une etape par ecran, un clic pour avancer. C'est ce clic qui rend le
         churn mesurable : sans lui, on ne sait pas ou le visiteur s'arrete.
         Le chiffre courant reste visible du debut a la fin (option A). */
      var q = '';

      q += '<p class="apsc-collecte">Vos réponses sont enregistrées de façon anonyme, sans aucune ' +
           'donnée personnelle, pour améliorer l\'outil.</p>';

      q += '<div class="apsc-courant"><div class="apsc-courant__c"><span>Avec AlloPunaise</span><b>' +
           (ap.fourchette ? (eur(ap.bas) + ' à ' + eur(ap.haut)) : eur(ap.bas)) + '</b></div>' +
           '<div class="apsc-courant__c"><span>Avec un professionnel</span><b>' +
           (pro.enAttente ? '-' : (pro.horsGrille ? 'hors grille' : eur0(pro.central))) + '</b></div>' +
           '<div class="apsc-courant__c"><span>Votre travail</span><b>' + hm(tr.total) + '</b></div></div>';

      var pct = Math.round((etat.etape - 1) / NB_ETAPES * 100);
      q += '<div class="apsc-progres"><p class="apsc-progres__n">Étape ' + etat.etape + ' sur ' + NB_ETAPES + '</p>' +
           '<div class="apsc-progres__b"><i style="width:' + Math.max(pct, 6) + '%"></i></div></div>';

      if (etat.etape === 1) {
        q += '<div class="apsc-q"><p class="apsc-q__label">Quelle est votre situation ?</p>' +
          pastilles(cadres.map(function (x) { return { v: x.cle, l: x.titre }; }), etat.cadre, 'cadre') +
          (c.subq
            ? '<div class="apsc-subq"><p class="apsc-q__label">' + esc(c.subq.label) + '</p>' +
              '<p class="apsc-q__help">' + esc(c.subq.help) + '</p>' +
              pastilles(c.subq.options, etat.dejaPro, 'dejaPro', true) + '</div>'
            : '') + '</div>';
      } else if (etat.etape === 2) {
        q += '<div class="apsc-q"><p class="apsc-q__label">Quelle surface fait votre logement ?</p>' +
          '<p class="apsc-q__help">Sert a situer le devis d\'un professionnel, qui facture par tranches de surface.</p>' +
          '<div class="apsc-row"><input type="range" class="apsc-range" data-attr="surface" min="10" max="155" step="5" value="' +
          etat.surface + '"><span class="apsc-val">' + (etat.surface > 150 ? 'plus de 150' : etat.surface) + ' m²</span></div>' +
          '<div class="apsc-steppers" style="margin-top:14px">' +
          stepper('pieces', 'Pièces à traiter', pieces(), etat.pieces === null, 1, 12) + '</div>' +
          '<p class="apsc-mention">Le nombre de pièces est déduit de la surface. Il n\'entre pas dans le coût : ' +
          'il sert aux tâches et, en traitement complet, à la quantité de terre de diatomée.</p></div>';
      } else if (etat.etape === 3) {
        q += '<div class="apsc-q"><p class="apsc-q__label">Combien de couchages à traiter ?</p>' +
          '<p class="apsc-q__help">C\'est la seule variable de notre colonne : housses et pièges suivent les lits, ' +
          'pas la surface.</p><div class="apsc-steppers">' +
          stepper('couchages', 'Couchages', n, etat.couchages === null, 1, 10) +
          stepper('lits2p', 'dont 2 places', lits2p(), etat.lits2p === 0, 0, n) + '</div></div>';
      } else if (etat.etape === 4) {
        q += '<div class="apsc-q"><p class="apsc-q__label">Quelle quantité d\'affaires à traiter, hors literie ?</p>' +
          '<p class="apsc-q__help">Estimez en contenants - un carton de déménagement fait environ 55 L. Pré-rempli à ' +
          CONTENANTS_PAR_CHAMBRE + ' contenants par chambre, corrigez si besoin.</p>' +
          pastilles(GABARITS, etat.gabarit, 'gabarit', true) +
          '<div class="apsc-steppers" style="margin-top:10px">' +
          stepper('contenants', 'Nombre de contenants', contenants(), etat.contenants === null, 1, 60) + '</div>' +
          '<p class="apsc-mention">Soit ' + litres().toLocaleString('fr-FR') + ' L au total, dans ' + sacs() +
          ' sac' + (sacs() > 1 ? 's' : '') + ' protecteur' + (sacs() > 1 ? 's' : '') + ' de 90 L remplis à ' +
          tauxRemplissage() + ' % - un sac ne se ferme plus s\'il est plein à ras. Compter ' +
          hm(sacs() * MIN_PAR_SAC) + ' de mise en sac.</p></div>';
      } else {
        q += '<div class="apsc-q"><p class="apsc-q__label">Vous vivez en...</p>' +
          pastilles(LOGEMENTS, etat.logement, 'logement') + '</div>';
        q += '<div class="apsc-q"><p class="apsc-q__label">Des voisins infestés, à votre connaissance ?</p>' +
          pastilles(VOISINS, etat.voisins, 'voisins', true) + '</div>';
        q += '<div class="apsc-q apsc-q--last"><p class="apsc-q__label">Votre code postal</p>' +
          '<p class="apsc-q__help">Nécessaire pour ajuster le prix : les tarifs professionnels sont ' +
          'majorés de 20 % en Île-de-France.</p>' +
          '<div class="apsc-row"><input type="text" class="apsc-cp" data-attr="cp" inputmode="numeric" maxlength="5" ' +
          'placeholder="75011" value="' + esc(etat.cp) + '"><span class="apsc-cp-note">' +
          (estIDF() ? 'Majoration Île-de-France appliquée (x1,20)' : 'Tarifs hors Île-de-France') + '</span></div></div>';
      }

      if (etat.etape === NB_ETAPES && etat.cp.length !== 5) {
        q += '<p class="apsc-nav__bloque">Saisissez votre code postal pour afficher les estimations.</p>';
      }
      q += '<div class="apsc-nav">' +
        (etat.etape > 1 ? '<button type="button" class="apsc-nav__prev" data-apsc-prev>Retour</button>' : '<span></span>') +
        (etat.etape < NB_ETAPES
          ? '<button type="button" class="apsc-cta" data-apsc-next>Continuer</button>'
          /* Le code postal conditionne la majoration Ile-de-France, donc tout le
             comparatif : il est obligatoire depuis le 2026-08-24 (dev). */
          : '<button type="button" class="apsc-cta" data-apsc-go' +
            (etat.cp.length === 5 ? '' : ' disabled') + '>Obtenir mes estimations</button>') +
        '</div>';

      zoneQ.innerHTML = q;

      /* Le teaser vit dans le <summary>, seule partie visible tant que le
         panneau est replie (options A + B tenues ensemble). */
      if (zoneT) {
        /* Teaser : le comparatif en trois lignes, deux colonnes (dev, 2026-08-24).
           Les deux montants tombent a la meme hauteur, seule facon de les comparer
           d'un coup d'oeil - en phrase ils etaient noyes a des positions differentes. */
        var prev = (c.mode === 'prevention');
        var tzAp  = ap.fourchette ? (eur(ap.bas) + ' à ' + eur(ap.haut)) : eur(ap.bas);
        var tzPro = pro.enAttente ? '-' : (pro.horsGrille ? 'sur devis' : eur0(pro.central));
        var tzTp = travailPro(c);
        var trPro = prev ? 'sans objet' : (tzTp ? hArrondi(tzTp.total) : '-');
        var duPro = prev ? 'sans objet' : ((SUIVI_SEMAINES + PRO_ENTRE_PASSAGES_SEM) + ' semaines et plus');
        function ligneTz(lbl, a, b) {
          return '<tr><th scope="row">' + lbl + '</th>' +
                 '<td class="is-ap">' + a + '</td><td>' + b + '</td></tr>';
        }
        zoneT.innerHTML =
          '<p class="apsc-tz__pour">Pour ' + esc(c.court || '') + ' de ' + etat.surface +
            ' mètres carrés et ' + enLettres(n) + ' couchage' + (n > 1 ? 's' : '') + '</p>' +
          '<table class="apsc-tz"><thead><tr><td></td>' +
            /* Formulation validee par le dev le 2026-08-24 : les deux colonnes se
               nomment en entier, on ne les abrege pas en « AlloPunaise / Pro ». */
            '<th scope="col">Avec la méthode<br>AlloPunaise</th>' +
            '<th scope="col">Avec intervention chimique<br>par un professionnel</th>' +
          '</tr></thead><tbody>' +
            ligneTz('Coût', tzAp, tzPro) +
            ligneTz('Votre travail', 'environ ' + hArrondi(tr.total), trPro) +
            ligneTz('Durée<br><span class="apsc-tz__sub">traitement + suivi</span>',
                    esc(c.calendaire || '-'), duPro) +
          '</tbody></table>' +
          (prev ? '' :
            '<p class="apsc-tz__note">La <b>période de suivi d\'infestation</b> - <b>' + SUIVI_SEMAINES +
            ' semaines</b> - est la même dans les deux cas. Le professionnel y ajoute le délai de ' +
            'rendez-vous et les 15 jours entre ses deux passages ; notre traitement se fait en une fois.</p>') +
          '<span class="apsc-header__cta" aria-hidden="true">Obtenir mon estimation personnalisée</span>';
      }

      /* La charge se construit AVANT la sortie anticipee : un abandon doit dire
         ce que le visiteur avait rempli au moment ou il est parti. */
      charge = charger(c, pro, ap, tr);

      if (!etat.calcule) { zoneR.hidden = true; zoneR.innerHTML = ''; return; }

      var montantAp = ap.fourchette ? ('de ' + eur(ap.bas) + ' à ' + eur(ap.haut)) : eur(ap.bas);
      var detailAp = n > 1
        ? ('Panier de base ' + eur(ap.base) + ', plus ' + (n - 1) + ' couchage' + (n > 2 ? 's' : '') +
           ' à équiper - ' + esc(c.incrTxt) + '.')
        : 'Panier complet, un couchage. Sommier tapissier ; à lattes, compter environ 25 € de plus.';

      var proMontant, proDetail;
      if (pro.enAttente) { proMontant = '-'; proDetail = 'En attente de votre réponse ci-dessus.'; }
      else if (pro.horsGrille) { proMontant = 'hors grille'; proDetail = 'Les grilles publiées s\'arrêtent à 150 m².'; }
      else {
        proMontant = eur0(pro.bas) + ' à ' + eur0(pro.haut);
        proDetail = pro.titre + ', ' + pro.note + '. Milieu de la fourchette ' + eur0(pro.central) +
          ', tranche ' + pro.tranche + ', d\'après les grilles publiées par les professionnels en ' + DATE_RELEVE + '.';
        /* Cadre 1 : la depense n'est pas le 3e passage seul, c'est ce qui a deja
           ete paye PLUS ce 3e passage (dev, 2026-08-24). */
        /* L'en-tete reste le cout A VENIR : c'est lui qui porte la decision, et
           c'est lui que le verdict compare. Le deja-paye vient ensuite, comme
           contexte - il est identique quelle que soit la suite choisie, donc il
           ne peut pas departager les deux colonnes. */
        if (pro.dejaPaye) {
          proDetail += ' <b>À quoi s\'ajoute ce que vous avez déjà payé</b> : environ ' +
            eur0(pro.dejaPaye) + ' pour les deux premiers passages, estimation d\'après votre surface ' +
            '(de ' + eur0(pro.dejaPayeBas) + ' à ' + eur0(pro.dejaPayeHaut) + '), soit <b>' +
            eur0(pro.dejaPaye + pro.central) + ' au total</b> engagés dans la voie chimique.';
        }
      }

      var proTravail, tp = travailPro(c);
      if (c.mode === 'prevention') { proTravail = { v: 'sans objet', d: "Il n'y a pas d'infestation à préparer." }; }
      else if (!tp) { proTravail = { v: '-', d: 'En attente de votre réponse ci-dessus.' }; }
      else {
        proTravail = { v: hm(tp.total),
          d: 'Par pièce et avant chaque passage : ' + PRO_CATHEDRALE_MIN + ' min de remise en cathédrale ' +
             'pour le matelas et le sommier, ' + PRO_DEGAGEMENT_MIN + ' min pour dégager le mobilier, plus ' +
             hm(sacs() * MIN_PAR_SAC) + ' de mise en sac. Soit ' + hm(tp.parPassage) + ' par passage, et ' +
             tp.passages + ' passage' + (tp.passages > 1 ? 's' : '') + ' à préparer.' };
      }
      var proCal = (c.mode === 'prevention')
        ? { v: 'sans objet', d: '' }
        : { v: 'environ ' + (SUIVI_SEMAINES + PRO_ENTRE_PASSAGES_SEM) + ' semaines, plus le délai de rendez-vous',
            d: 'Un premier passage, un second 15 jours plus tard, puis la même période de suivi de ' +
               SUIVI_SEMAINES + ' semaines.' };

      /* Ordre des axes, arbitrage du dev du 2026-08-24 : la certitude d'en venir
         a bout d'abord, l'argent ensuite, le temps en troisieme. Ce que le
         visiteur achete, c'est une issue - pas un prix. */
      var r = '<p class="apsc-result__title">Votre situation, point par point</p>';

      r += axe("Certitude d'en venir à bout", esc(c.certitude), esc(c.certitudeD), 'Variable',
        'Le traitement chimique bute sur la résistance : dès 2012, 37,8 % des punaises d\'un site de ' +
        'banlieue parisienne y résistaient déjà (Durand, 2012).', false, '🎯');
      r += '<p class="apsc-mention"><a class="apsc-savoirplus" target="_blank" rel="noopener" ' +
        'href="https://allopunaise.com/blogs/traitement-punaise-de-lit/traitement-chimique-insecticide-punaise-de-lit">' +
        'Pour en savoir plus sur l\'efficacité réelle des insecticides chimiques</a></p>';

      r += axe('Coût', montantAp, detailAp, proMontant, proDetail, pro.enAttente || pro.horsGrille, '💰');
      /* Ce que le montant ne dit pas, et qui ne se calcule pas : la nature de la
         depense. Un passage de desinsectiseur se consomme le jour meme ; une
         partie de ce panier est un equipement qui reste.
         Sources : housse CleanRest PRO certifiee anti-punaise de lit ET anti-acariens
         (dev, 2026-08-24 - la fiche produit ne porte que « anti-allergenes », la
         certification acariens est a y ajouter). Pieges OmniGuard « reutilisable a
         l'infini », « bloque pour un temps illimite » (fiche produit, verbatim) ;
         pieges UNIVERSELS : bloquent toujours sans leurs disques collants (dev,
         2026-08-24 - non ecrit sur leur fiche, a y ajouter). */
      var durable = coutDurable(c);
      var pctDurable = ap.bas ? Math.round(durable / ap.bas * 100) : 0;
      r += '<p class="apsc-mention"><b>Une partie de ce panier n\'est pas une dépense, ' +
        'c\'est un équipement.</b> Le passage d\'un désinsectiseur se consomme le jour même et ne ' +
        'laisse rien derrière lui. Ici, les housses restent en place sur le matelas et le sommier - ' +
        'elles sont certifiées contre les punaises de lit et contre les acariens - et les pièges, ' +
        'universels comme OmniGuard, ont une durée de vie illimitée : même sans leurs disques ' +
        'collants ou silicate de magnésium, ils continuent de bloquer les punaises, et ils ' +
        'resservent au moindre doute.' +
        /* La phrase sur la vapeur ne s'affiche que sur les cadres qui en portent une. */
        (c.base.some(function (l) { return String(l.url || '').indexOf('nettoyeur-vapeur') !== -1; })
          ? ' Quant au nettoyeur vapeur, il s\'utilise ensuite pour le ménage quotidien.' : '') +
        (durable > 0
          ? ' <b>Sur ce panier, ' + eur(durable) + ' sont des équipements qui restent</b>, soit ' +
            pctDurable + ' % du montant.'
          : '') + '</p>';

      r += axe('Temps de travail', hm(tr.total),
        'Manipulation seule, hors temps de machine : ' + esc(c.travailD) +
        (tr.sac ? (', et ' + hm(tr.sac) + ' de mise en sac') : '') + '.',
        proTravail.v, proTravail.d, c.mode === 'prevention', '⏱️');

      r += axe('Durée', esc(c.calendaire), esc(c.calendaireD), proCal.v, proCal.d, c.mode === 'prevention', '📅');
      if (c.mode !== 'prevention') {
        r += '<p class="apsc-mention">La période de suivi d\'infestation - ' + SUIVI_SEMAINES +
          ' semaines - est la même quelle que soit la méthode : elle dépend du cycle de l\'insecte, ' +
          'pas de qui traite. Ce qui diffère, c\'est la phase de traitement : elle se fait en une fois ' +
          'avec notre méthode, contre un rendez-vous puis deux passages espacés de 15 jours avec un ' +
          'professionnel.</p>';
      }

      r += axe('Vigilance santé', 'Aucun insecticide rémanent', esc(c.vigilance), 'Insecticide rémanent',
        'Il reste en place après le passage pendant une durée inconnue, dans les pièces où vous vivez.', false, '⚠️');

      r += verdict(c, pro, ap);
      if (c.mode !== 'prevention') { r += '<div class="apsc-block">' + voies() + '</div>'; }

      r += '<div class="apsc-block"><p class="apsc-block__h">Les produits de ce protocole</p>' +
        '<div class="apsc-prods">' + produits(c) + '</div>' +
        '<p class="apsc-mention">' + (c.option
          ? ('En cas de récidive, le ' + esc(c.option.nom) + ' à ' + eur(c.option.prix / 100) +
             ' ferme le couchage et porte la certitude à très élevée.')
          : 'Prix du jour, hors variantes de dimensions.') + '</p></div>';

      /* Les consommables et leur modulation, rendus explicitement : c'est le
         seul endroit ou le visiteur voit pourquoi la quantite bouge. */
      var cons = consommables(c);
      var lignesC = cons.lignes.filter(function (x) { return x.requis > 0; });
      if (lignesC.length) {
        r += '<div class="apsc-block"><p class="apsc-block__h">Les consommables, selon votre situation</p>' +
          '<table class="apsc-conso"><thead><tr><th>Consommable</th><th>Il en faut</th><th>Compris</th>' +
          '<th>À ajouter</th></tr></thead><tbody>' +
          lignesC.map(function (x) {
            var det = x.sup
              ? x.cond.lignes.map(function (l) {
                  return (l.q > 1 ? (l.q + ' x ') : '') + esc(l.titre) + ' - ' + eur(l.prix * l.q);
                }).join('<br>')
              : 'rien à ajouter';
            return '<tr><td data-l="Consommable">' + esc(x.f.lbl) + '</td>' +
                   '<td data-l="Il en faut">' + x.requis + '</td>' +
                   '<td data-l="Compris">' + x.inclus + '</td>' +
                   '<td data-l="À ajouter">' + det + '</td></tr>';
          }).join('') +
          '</tbody></table>' +
          '<p class="apsc-mention">' + esc(NOTE_CONSO[c.cle] || '') + '</p>' +
          (cons.total
            ? ('<p class="apsc-mention"><b>' + eur(cons.total) + '</b> de consommables en plus du panier de base, ' +
               'au conditionnement le moins cher.</p>')
            : '') + '</div>';
      }

      r += '<div class="apsc-block"><p class="apsc-block__h">Pour aller plus loin</p><div class="apsc-links">' +
        '<a class="apsc-link" target="_blank" rel="noopener" href="https://allopunaise.com/blogs/produits-anti-punaise-de-lit/punaise-de-lit-congelateur">' +
        'Consulter l\'article congélateur<span>Quelle température, quelle durée, quels appareils conviennent</span></a>' +
        '<a class="apsc-link" target="_blank" rel="noopener" href="https://allopunaise.com/blogs/traitement-punaise-de-lit/punaise-de-lit-machine-a-laver">' +
        'Consulter l\'article machine à laver<span>Températures, cycles et séchage pour le textile</span></a>' +
        (data.lien_methode
          ? ('<a class="apsc-link apsc-link--method" href="' + esc(data.lien_methode) + '">' +
             'Voir la méthode complète, étape par étape' +
             '<span>Le protocole détaillé, geste par geste</span></a>')
          : '') +
        '</div></div>';

      var notes = [];
      if (c.mode !== 'prevention') {
        notes.push('Un client sur deux nous rejoint après être passé par un désinsectiseur - 134 clients interrogés ' +
          'par questionnaire post-commande, sur les deux mois écoulés depuis juillet 2026.');
      }
      if (etat.voisins === 'oui') {
        notes.push('Des voisins infestés : les pièges sous les pieds de lit et la protection des ouvrants comptent ' +
          'autant que le traitement lui-même.');
      }
      if (etat.logement !== 'maison_individuelle') {
        notes.push("En habitat collectif, le traitement des parties communes relève du syndic : signalez " +
          "l'infestation, votre logement seul ne suffira pas.");
      }
      /* L'ancienne phrase generique « les consommables partages - diatomee,
         sacs - ne se multiplient pas par couchage » etait fausse sur 3 cadres
         sur 4, et decrivait le contenu d'offres inconnues. Elle est remplacee
         par la note propre au cadre, rendue dans le bloc consommables. */
      r += '<ul class="apsc-notes">' + notes.map(function (t) { return '<li>' + t + '</li>'; }).join('') + '</ul>';

      r += '<div class="apsc-retour">' +
        '<label class="apsc-retour__lbl" for="apsc-retour-' + uid + '">' +
        'Faire un retour pour améliorer ce calculateur</label>' +
        '<textarea class="apsc-retour__champ" id="apsc-retour-' + uid + '" rows="2" maxlength="500" ' +
        'placeholder="Ce qui vous a manqué, ce qui vous a semblé faux..."></textarea>' +
        '<button type="button" class="apsc-retour__btn" data-apsc-retour>Envoyer mon retour</button>' +
        '<p class="apsc-retour__note" data-apsc-retour-note>Anonyme. N\'y mettez ni nom, ni adresse, ' +
        'ni téléphone : nous n\'en avons pas besoin et nous ne les conserverions pas.</p>' +
        '</div>';

      r += '<p class="apsc-mention">Colonne professionnelle : synthèse de grilles publiées en ' + DATE_RELEVE +
        ', deux passages inclus, TTC' + (estIDF() ? ', majorée pour l\'Île-de-France' : ', hors Île-de-France') +
        '. Ce n\'est pas une médiane de marché. Notre colonne est un panier de produits au prix du jour, et le temps ' +
        'affiché est un temps de manipulation, hors temps de machine.</p>';

      zoneR.innerHTML = r;
      zoneR.hidden = false;
      charge = charger(c, pro, ap, tr);
    }

    /* --- Collecte -------------------------------------------------------- */
    var charge = null, envoye = false;
    function charger(c, pro, ap, tr) {
      return {
        type: 'simulation',
        version: (data.transport && data.transport.version) || '',
        /* Trois colonnes ajoutees le 2026-08-24 :
           - `session` recolle les lignes d'une meme visite. `visibilitychange`
             part a chaque bascule d'onglet, pas seulement au depart : sans elle
             un visiteur qui sort et revient ecrit un abandon PUIS une
             simulation, et le churn par etape est fausse.
           - `page` : deux pages portent le composant et rien ne les distingue.
           - `etape_max` : la marche ou le visiteur s'est arrete. */
        session: SESSION,
        page: location.pathname,
        etape_max: etat.etapeMax,
        cadre: c.cle, deja_pro: etat.dejaPro || '',
        surface: etat.surface, pieces: pieces(), couchages: couchages(), lits_2p: lits2p(),
        gabarit: etat.gabarit, contenants: contenants(), sacs: sacs(),
        sacs_corrige: etat.contenantsCorrige,
        logement: etat.logement, voisins: etat.voisins,
        departement: etat.cp.length === 5 ? etat.cp.slice(0, 2) : '',
        cout_bas: ap.bas.toFixed(2), cout_haut: ap.haut.toFixed(2),
        pro_central: pro.central ? pro.central.toFixed(2) : '',
        travail_min: tr.total,
        website: ''   /* champ piège : rempli = robot, la ligne est abandonnée côté script */
      };
    }
    function poster(charge) {
      var url = data.transport && data.transport.url_collecte;
      if (!url) return false;
      try {
        navigator.sendBeacon(url, new Blob([JSON.stringify(charge)], { type: 'text/plain;charset=UTF-8' }));
        return true;
      } catch (e) { return false; }   /* la collecte ne doit jamais casser la page */
    }
    /* Le retour part sur SA propre ligne, typee `retour` : une ligne = un
       evenement. Il arrive apres le calcul, donc il ne peut pas rejoindre la
       ligne deja ecrite - un classeur ne se met pas a jour, il s'ajoute. */
    var retourEnvoye = false;
    function envoyerRetour() {
      if (retourEnvoye) return;
      var champ = root.querySelector('.apsc-retour__champ');
      var note = root.querySelector('[data-apsc-retour-note]');
      var texte = champ ? String(champ.value || '').trim() : '';
      if (!texte) { if (note) note.textContent = 'Écrivez quelques mots avant d\'envoyer.'; return; }
      var ok = poster({ type: 'retour', version: (data.transport && data.transport.version) || '',
                        cadre: etat.cadre, retour: texte.slice(0, 500), website: '' });
      retourEnvoye = true;
      if (champ) { champ.value = ''; champ.disabled = true; }
      if (note) note.textContent = ok ? 'Merci, c\'est envoyé.' : 'Retour non transmis, la collecte est fermée.';
    }
    function envoyer() {
      var url = data.transport && data.transport.url_collecte;
      if (!url || envoye || !charge) return;
      envoye = true;
      poster(charge);
    }
    /* Deux natures d'envoi, et une seule ligne par visite dans les deux cas :
         - le clic sur le CTA ecrit une ligne `simulation` ;
         - le depart de la page SANS ce clic ecrit une ligne `abandon`, qui dit
           ce que le visiteur avait rempli avant de renoncer (dev, 2026-08-21).
       Un visiteur qui calcule n'ecrit donc jamais d'abandon, et reciproquement. */
    var abandonEnvoye = false;
    function envoyerAbandon() {
      /* Aucune ligne pour une simple vue : le classeur ne comptait jusqu'ici
         que des vues de page, d'ou les « 97 % d'abandons » du 2026-08-24.
         Le denominateur se lit desormais dans GA4 (arbitrage du dev). */
      if (etat.etapeMax === 0) return;
      if (envoye || abandonEnvoye || !charge) return;
      abandonEnvoye = true;
      var copie = {};
      for (var k in charge) { if (charge.hasOwnProperty(k)) copie[k] = charge[k]; }
      copie.type = 'abandon';
      poster(copie);
    }
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'hidden') envoyerAbandon();
    });
    window.addEventListener('pagehide', envoyerAbandon);

    /* Denominateur echantillonne. Depuis le 24/08 rien ne s'ecrit tant que le
       panneau reste replie : une semaine a zero ne dit donc pas si la collecte
       est morte ou si personne n'ouvre. Constate le 2026-08-31 - cinq jours a
       zero, toute la chaine verifiee saine, et aucun moyen de le prouver depuis
       le classeur. Une vue sur dix laisse une ligne `vue` : ~2/jour au trafic
       actuel, de quoi rendre le zero lisible sans revenir aux 30-40 lignes/jour
       de l'artefact demonte le 24/08. Le denominateur fin reste dans GA4.
       Revient en partie sur l'arbitrage du 2026-08-24, a la demande du dev. */
    var TAUX_VUE = 0.1;
    if (Math.random() < TAUX_VUE) {
      poster({ type: 'vue', version: (data.transport && data.transport.version) || '',
               cadre: etat.cadre, session: SESSION, page: location.pathname,
               etape_max: 0, website: '' });
    }

    /* --- Événements - pas de bouton « calculer » ------------------------- */
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-apsc-retour]')) { envoyerRetour(); return; }
      if (e.target.closest('[data-apsc-next]')) {
        etat.etape = Math.min(NB_ETAPES, etat.etape + 1);
        etat.etapeMax = Math.max(etat.etapeMax, etat.etape);
        render();
        if (zoneQ.scrollIntoView) zoneQ.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (e.target.closest('[data-apsc-prev]')) {
        etat.etape = Math.max(1, etat.etape - 1);
        render();
        return;
      }
      if (e.target.closest('[data-apsc-go]')) {
        etat.etapeMax = NB_ETAPES;
        etat.calcule = true;
        render();
        envoyer();                 /* une ligne par simulation demandee, jamais deux */
        var res = root.querySelector('[data-apsc-result]');
        if (res && res.scrollIntoView) res.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      var p = e.target.closest('.apsc-pill');
      if (p) {
        var a = p.getAttribute('data-attr'), v = p.getAttribute('data-v');
        if (a === 'cadre') { etat.cadre = v; etat.dejaPro = null; }
        else if (a === 'gabarit') { etat.gabarit = parseInt(v, 10); }
        else { etat[a] = v; }
        render(); return;
      }
      var b = e.target.closest('.apsc-stepper__btn');
      if (b) {
        var at = b.getAttribute('data-attr'), pas = parseInt(b.getAttribute('data-step'), 10);
        if (at === 'pieces') etat.pieces = Math.max(1, pieces() + pas);
        if (at === 'couchages') {
          etat.couchages = Math.max(1, couchages() + pas);
          etat.lits2p = Math.min(etat.lits2p, etat.couchages);
        }
        if (at === 'lits2p') etat.lits2p = Math.min(Math.max(0, lits2p() + pas), couchages());
        if (at === 'contenants') { etat.contenants = Math.max(1, contenants() + pas); etat.contenantsCorrige = 1; }
        render();
      }
    });
    root.addEventListener('input', function (e) {
      var t = e.target;
      if (t.classList.contains('apsc-range')) {
        etat.surface = parseInt(t.value, 10);
        etat.pieces = null; etat.couchages = null; etat.lits2p = 0;
        render();
      } else if (t.classList.contains('apsc-cp')) {
        etat.cp = t.value.replace(/\D/g, '').slice(0, 5);
        render();
        var champ = root.querySelector('.apsc-cp');
        if (champ) { champ.focus(); champ.setSelectionRange(champ.value.length, champ.value.length); }
      }
    });

    /* L'ouverture du panneau est la marche que rien ne mesurait : un visiteur
       pouvait deplier puis refermer sans laisser de trace. */
    root.addEventListener('toggle', function () {
      if (root.open && etat.etapeMax === 0) { etat.etapeMax = 1; render(); }
    });

    render();
  }

  function demarrer() {
    var noeuds = document.querySelectorAll('.apsc[data-apsc]');
    for (var i = 0; i < noeuds.length; i++) mount(noeuds[i]);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', demarrer);
  else demarrer();
})();
